import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroupDirective, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
//import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';
import { Router } from '@angular/router';
import { AlertComponent } from 'src/app/alert/alert.component';
import { LoginServiceService } from 'src/app/services/api/login-service.service';
import { SnackBarService } from 'src/app/services/SharedServices/snack-bar.service';
import { LoaderComponent } from 'src/app/Shared Components/loader/loader.component';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';
import { environment } from 'src/environments/environment';
interface Role {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {

  private LoadeRef : MatDialogRef<LoaderComponent>;
  roles: Role[] = [
    {value: 'User', viewValue: 'User'},
    {value: 'Admin', viewValue: 'Admin'}
  ];
userForm : any;
  constructor(private router: Router, private formBuilder: FormBuilder,private _loginService : LoginServiceService,private snackservice : SnackBarService,
    private _snackBar: MatSnackBar) { }


  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      Firstname: ['', [Validators.required]],
      Lastname: ['',[Validators.required]],
      Email: ['', [Validators.required]],
      Username: ['', [Validators.required]],
      PhoneNo: [''],
      Role :  ['', [Validators.required]],

    });
  }

  onSubmit(e, formDirective){

    if(this.userForm.valid){
      var p = {
        Person : e,
        password : "",
        ClientUrl : environment.DefaultURL
      }
      p.Person["RememberMe"] = true;
      this.snackservice.loader();
      this._loginService.CreateUser(p).subscribe((res) => {
        console.log(res);
        const options = {
          title: 'Succesful',
          message: 'User is created successfully',
          cancelText: 'Ok',
          //confirmText: 'Confirm'
        };
        setTimeout(() => {
          this.snackservice.CloseProgressSpinner(true);
          setTimeout(() => {
            this.snackservice.open(options);
            // this.router.navigate(['/login']);
            this.resetForm(this.userForm.value,formDirective)
          },200);
        },400);
    },
    (err) => {
      console.log(err);
      const options = {
        title: 'Failed',
        message: 'User creation failed,Please try again',
        cancelText: 'Ok',
        //confirmText: 'Confirm'
      };
      setTimeout(() => {
        this.snackservice.CloseProgressSpinner(true);
        setTimeout(() => {
          this.snackservice.open(options);
        },200);
      },400);

        })

    } else {

      setTimeout(() => {
        this.snackservice.CloseProgressSpinner(true);
        setTimeout(() => {
          this.openSnackBar('User form is not valid','error')
        },200);
      },400);

    }
  }

  private resetForm(formData: any, formDirective: FormGroupDirective): void {
    formDirective.resetForm();
    this.userForm.reset();
}
  openSnackBar(message: string, messageType:'error'|'success'|'notification') {
    let config = new MatSnackBarConfig();
    config.data = {
      message: message,
      type:messageType
    };
    config.duration = environment.messageTimeOut;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass =messageType;
    this._snackBar.openFromComponent(SnackbarComponent, config);
  }
}
